export default {
    setAuthInfo(info) {
        localStorage.setItem('userAuthInfo', JSON.stringify(info));
    },
    getAuthInfo(){
        let authInfo = localStorage.getItem('userAuthInfo');
        return authInfo ? JSON.parse(authInfo) : null;
    },
    clearAuthInfo(){
        localStorage.removeItem('userAuthInfo');
    },
    isLogin(){
        return this.getAuthInfo() !== null;
    }
};



// WEBPACK FOOTER //
// ./src/assets/js/auth.js